import {noop} from "lodash";
import React, {useEffect, useMemo, useState} from "react";
import BasicText, {BasicNumber} from "../../components/form-v2/basic-text";
import {BlueButton, RedButton} from "../../components/ui/Buttons";
import {CountryRule, RiskRule} from "./types";
import {countries} from "../../lib/countries"

type CountryRowProps = {
    index: number
    row: CountryRule
    remove?: (index: number) => void
    update?: (index: number, row: CountryRule) => void
}

export function CountryRow({
                            index,
                            row,
                            remove = noop,
                            update = noop,
                        }: CountryRowProps) {




    const [countryISO, setCountryISO] = useState<string>(row.countryISO);
    const [times, setTimes] = useState<string[]>(row.times)
    const [arrivalTravel, setArrivalTravel] = useState(row.onArrivalTravel)
    const [arrivalAccommodation, setArrivalAccommodation] = useState(row.onArrivalAccommodation)
    const [departureTravel, setDepartureTravel] = useState(row.onDepartureTravel)
    const [departureAccommodation, setDepartureAccommodation] = useState(row.onDepartureAccommodation)
    const [timeGracePeriod, setTimeGracePeriod] = useState(row.timeGracePeriod)
    const [arrivalGracePeriod, setArrivalGracePeriod] = useState(row.arrivalGracePeriod)
    const [departureGracePeriod, setDepartureGracePeriod] = useState(row.departureGracePeriod)


    useEffect(() => {
        update(index, {
            countryISO: countryISO,
            times: times,
            onArrivalTravel: arrivalTravel,
            onArrivalAccommodation: arrivalAccommodation,
            onDepartureTravel: departureTravel,
            onDepartureAccommodation: departureAccommodation,
            timeGracePeriod: timeGracePeriod,
            arrivalGracePeriod: arrivalGracePeriod,
            departureGracePeriod: departureGracePeriod,
        })

    }, [index, countryISO, times, arrivalTravel, arrivalAccommodation, departureTravel, departureAccommodation, timeGracePeriod, arrivalGracePeriod, departureGracePeriod])

    const addTime = () => {
        if (times.length == 0 || times[times.length - 1] != "") {
            setTimes([...times, ""])

        }
    }

    const removeTime = () => {
        const newTimes = [...times]
        newTimes.splice(newTimes.length - 1)
        setTimes(newTimes)
    }

    const updateTime = (value: string, index: number) => {
        const newTimes = [...times]
        newTimes[index] = value
        setTimes(newTimes)
    }

    const country = useMemo(() => {
        const res = countries.find((c => c.countryCode === countryISO))
        if(res){
            return {
                name: res.countryNameEn,
                flag: res.flag,
            }
        }

        return {
            name: "unknown",
            flag: ""
        }


    }, [countryISO])


    return (
        <div className={"py-3 grid grid-cols-5 w-full items-start"}>
            <div className={"px-4"}>
                {country.flag} {country.name}
            </div>


            <div className={"px-4 text-center"}>
                <div className={"flex flex-col gap-4"}>
                    {times.map((t, i) => <BasicText value={t} key={i} type={"time"} center={true}
                                                    onChange={(t) => updateTime(t, i)}/>)}
                    {times.length != 0 && <RedButton text={"Remove Time"} onClick={removeTime}/>}
                    <div className={(times.length == 0 || times[times.length - 1] != "") ? "" : "opacity-50"}>
                        <BlueButton
                            text={"Add Time"} onClick={addTime}/></div>
                </div>

                {times.length != 0 &&
                    <div className={"pt-4"}>
                        <label className={"font-semibold"}>Grace Period</label>
                        <BasicNumber type={"number"} value={timeGracePeriod} min={15} max={240}
                                     onChange={setTimeGracePeriod}
                        />
                    </div>
                }
            </div>


            <div className={"px-4 text-center h-full flex flex-col py-3"}>
                <div className={"flex flex-col gap-2 mb-4"}>
                    <label className={"font-semibold"}>Travel</label>
                    <input className={"scale-[1.5]"} type={"checkbox"} checked={arrivalTravel}
                           onChange={(e) => setArrivalTravel(e.target.checked)}/>
                </div>
                <div className={"flex flex-col gap-2"}>

                    <label className={"font-semibold"}>Accommodation</label>
                    <input className={"scale-[1.5]"} type={"checkbox"} checked={arrivalAccommodation}
                           onChange={(e) => setArrivalAccommodation(e.target.checked)}/>
                </div>

                {(arrivalTravel || arrivalAccommodation) &&
                    <div className={"pt-4"}>
                        <label className={"font-semibold"}>Grace Period</label>
                        <BasicNumber type={"number"} value={arrivalGracePeriod} min={15} max={240}
                                     onChange={setArrivalGracePeriod}
                        />
                    </div>
                }
            </div>
            <div className={"px-4 text-center h-full flex flex-col pt-3"}>
                <div className={"flex flex-col gap-2 mb-4"}>
                    <label className={"font-semibold"}>Travel</label>
                    <input className={"scale-[1.5]"} type={"checkbox"} checked={departureTravel}
                           onChange={(e) => setDepartureTravel(e.target.checked)}/>
                </div>
                <div className={"flex flex-col gap-2"}>

                    <label className={"font-semibold"}>Accommodation</label>
                    <input className={"scale-[1.5]"} type={"checkbox"} checked={departureAccommodation}
                           onChange={(e) => setDepartureAccommodation(e.target.checked)}/>
                </div>


                {(departureTravel || departureAccommodation) &&
                    <div className={"pt-4"}>
                        <label className={"font-semibold"}>Grace Period</label>
                        <BasicNumber type={"number"} value={departureGracePeriod} min={15} max={240}
                                     onChange={setDepartureGracePeriod}
                        />
                    </div>
                }
            </div>

            <div className={"px-4"}>
                {<RedButton text={"Remove"} onClick={() => remove(index)}/>}
            </div>
        </div>
    )

}

